import { TADManager } from "tad-core";
import { Shark, Utils } from "shark-mvc";
import "Models/Refuel";

var refuelManager = Shark.createJaw("refuelManager");

refuelManager.addMethod("save", function (refuel) {
	const action = "create";

	TADManager.clearCollection();
	TADManager.createTAD({ t: "refuel", a: action, d: [refuel.export()]});

	TADManager.sendDefaultCollection(function (response) {
		var responseTAD = response.getItem(0);
		console.log({ where: "refuelManager > save > apiResponse", response: response, responseTAD: responseTAD });

		switch (responseTAD.checkResponseStatus()) {
			case "ok":
                refuel.import(responseTAD.responseData[0].data);
                refuel.clean();
                
				refuelManager.emit("saved");
				break;
			case "ko":
				refuelManager.emit("saveError", responseTAD.lastErrorMessage);
				break;
		}
	});
});

Shark.registerController(refuelManager);

export { refuelManager };